import { render, staticRenderFns } from "./editionsComparison.vue?vue&type=template&id=a347184c&scoped=true"
import script from "./editionsComparison.vue?vue&type=script&lang=js"
export * from "./editionsComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a347184c",
  null
  
)

export default component.exports